import React, { useState, useEffect, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { loaderDelay } from '@utils';

interface StyledSideElementProps {
  orientation: 'left' | 'right';
}

const StyledSideElement = styled.div<StyledSideElementProps>`
  width: 40px;
  position: fixed;
  bottom: 0;
  left: ${props => (props.orientation === 'left' ? '40px' : 'auto')};
  right: ${props => (props.orientation === 'left' ? 'auto' : '40px')};
  z-index: 10;
  color: var(--light-slate);

  @media (max-width: 1080px) {
    left: ${props => (props.orientation === 'left' ? '20px' : 'auto')};
    right: ${props => (props.orientation === 'left' ? 'auto' : '20px')};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

interface SideProps {
  children: React.ReactNode;
  isHome?: boolean;
  orientation: 'left' | 'right';
}

const Side: React.FC<SideProps> = ({ children, isHome, orientation }) => {
  const [isMounted, setIsMounted] = useState(!isHome);

  useEffect(() => {
    if (!isHome) {
      return;
    }
    const timeout = setTimeout(() => setIsMounted(true), loaderDelay);
    return () => clearTimeout(timeout);
  }, [isHome]);

  const sideRef = useRef<HTMLDivElement>(null);

  return (
    <StyledSideElement orientation={orientation}>
      <TransitionGroup component={null}>
        {isMounted && (
          <CSSTransition
            classNames={isHome ? 'fade' : ''}
            timeout={isHome ? loaderDelay : 0}
            nodeRef={sideRef}>
            <div ref={sideRef}>{children}</div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </StyledSideElement>
  );
};

export default Side;
